import { ColorOptions, LinksOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export interface IPageHeaderVersionState {
    /** Transparent background */
    transparent?: boolean;
    /** White text color */
    lightMode?: boolean;
    /** Hide up when start scrolling down */
    hideUp?: boolean;
}

export const PAGE_HEADER_BLOCK_ID = 'page-header'; // back forward compatibility for already saved data

export const PAGE_HEADER_VERSION_STATE: IPageHeaderVersionState = {
    transparent: false,
    lightMode: false,
    hideUp: false
};

export const menuField: NICmsContentField.IRepeaterField = {
    type: NICmsContentField.EFieldType.repeater,
    key: 'menu',
    title: 'Menu Items',
    itemName: 'Item',
    itemNameField: 'text',
    defaultSize: 3,
    complex:true,
    defaultPart: {
        components: []
    },
    fields: [
        {
            key: 'text',
            type: NICmsContentField.EFieldType.text,
            title: 'Item text',
            default: 'Some link',
            required: true
        },
        {
            key: 'link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        },
        <NICmsContentField.IChoiceField>{
            key: 'link_class',
            type: NICmsContentField.EFieldType.choice,
            title: 'Link Style',
            options: LinksOptions,
            default: LinksOptions[0] ? LinksOptions[0].key : undefined
        },
        <NICmsContentField.IChoiceField>{
            key: 'color',
            title: 'Color',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            options: ColorOptions,
            description: 'Text color'
        },<NICmsContentField.IRepeaterField>{
            key: 'columns',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Columns',
            itemName: 'Column',
            itemNameField: 'title',
            complex: true,
            fields: [
                <NICmsContentField.IField>{
                    key: 'title',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Column title',
                    description: 'Not used on website, used for iCMS column name only!'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'width',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Column Width',
                    required: true,
                    options: [
                        { key: 'c-2', title: 'Single column' },
                        { key: 'c-4', title: 'Double column' }
                    ],
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'list',
                    title: 'List',
                    itemName: 'Element',
                    itemNameField: 'text',
                    complex: true,
                    fields: [
                        <NICmsContentField.IField>{
                            key: 'title',
                            type: NICmsContentField.EFieldType.text,
                            title: 'List Header'
                        },
                        <NICmsContentField.IField>{
                            key: 'gtmSubcategory',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Subcategory for GTM'
                        },
                        <NICmsContentField.IChoiceField>{
                            key: 'variant',
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Variant',
                            required: true,
                            options: [
                                { key: 'links_list', title: 'List of links' },
                                { key: 'image', title: 'Image' },
                                { key: 'cta', title: 'CTA' }
                            ],
                            default: 'links_list'
                        },
                        <NICmsContentField.IField>{
                            key: 'image',
                            type: NICmsContentField.EFieldType.image,
                            title: 'Image',
                            canShow: data => data?.variant === 'image'
                        },
                        <NICmsContentField.IChoiceField>{
                            key: 'ratio',
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Image ratio',
                            required: true,
                            options: [
                                { key: 'ratio-1-1', title: '1x1' },
                                { key: 'ratio-2-1', title: '2x1' }
                            ],
                            default: 'ratio-1-1',
                            canShow: data => data?.variant === 'image'
                        },
                        <NICmsContentField.IField>{
                            key: 'text',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Text',
                            description: 'Underlined text at the bottom',
                            canShow: data => data?.variant === 'image'
                        },
                        <NICmsContentField.IField>{
                            key: 'link',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Link',
                            description: 'Link on the entire item',
                            canShow: data => data?.variant === 'image'
                        },
                        <NICmsContentField.IField>{
                            key: 'label',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Label',
                            description: 'Label text at the bottom',
                            canShow: data => data?.variant === 'image'
                        },
                        <NICmsContentField.IRepeaterField>{
                            key: 'linksList',
                            type: NICmsContentField.EFieldType.repeater,
                            title: 'List of links',
                            itemName: 'Link',
                            itemNameField: 'text',
                            complex: true,
                            fields: [
                                <NICmsContentField.IField>{
                                    key: 'withImage',
                                    type:  NICmsContentField.EFieldType.toggle,
                                    title: 'With image',
                                    default: false
                                },
                                <NICmsContentField.IField>{
                                    key: 'withColours',
                                    type:  NICmsContentField.EFieldType.toggle,
                                    title: 'With colours',
                                    default: false
                                },
                                <NICmsContentField.IField>{
                                    key: 'extraBorder',
                                    type: NICmsContentField.EFieldType.toggle,
                                    title: 'Extra border',
                                    default: false,
                                    description: 'Especialy for white colour',
                                    canShow: data => data?.withColours
                                },
                                {
                                    type:  NICmsContentField.EFieldType.colorPicker,
                                    key: 'colour',
                                    title: 'Colour picker',
                                    description: 'Colour picker',
                                    colorPreview: true,
                                    canShow: data => data?.withColours
                                },
                                <NICmsContentField.IField>{
                                    key: 'image',
                                    type:  NICmsContentField.EFieldType.image,
                                    title: 'Image',
                                    canShow: data => data?.withImage
                                },
                                <NICmsContentField.IField>{
                                    key: 'text',
                                    type: NICmsContentField.EFieldType.text,
                                    title: 'Text',
                                    required: true
                                },
                                <NICmsContentField.IField>{
                                    key: 'link',
                                    type: NICmsContentField.EFieldType.text,
                                    title: 'Link'
                                }
                            ],
                            canShow: data => data?.variant !== 'image' && data?.variant !== 'cta'
                        },
                        <NICmsContentField.IField>{
                            key: 'cta_url',
                            type: NICmsContentField.EFieldType.text,
                            title: 'CTA Url',
                            canShow: data => data?.variant === 'cta'
                        },
                        <NICmsContentField.IField>{
                            key: 'cta_label',
                            type: NICmsContentField.EFieldType.text,
                            title: 'CTA Label',
                            canShow: data => data?.variant === 'cta'
                        }
                    ]
                }
            ]
        },
        <NICmsContentField.IColorPickerField>{
            type:  NICmsContentField.EFieldType.colorPicker,
            key: 'promo_background_colour',
            title: 'Promo Background Colour',
            options: ColorOptions,
            colorPreview: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'promo_copy_colour',
            type: NICmsContentField.EFieldType.choice,
            colorPreview: true,
            title: 'Promo Copy Colour',
            options: ColorOptions
        },
        <NICmsContentField.IField>{
            key: 'promo_copy',
            type: NICmsContentField.EFieldType.text,
            title: 'Promo Copy'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'promo_ctas',
            type: NICmsContentField.EFieldType.repeater,
            title: 'List of promo CTAs',
            itemName: 'cta',
            itemNameField: 'promo_cta_label',
            fields: [
                <NICmsContentField.IField>{
                    key: 'promo_cta_label',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Promo CTA Label'
                },
                <NICmsContentField.IField>{
                    key: 'promo_cta_url',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Promo CTA Url'
                }
            ]
        }]

};

export const PAGE_HEADER_VERSION_CONFIG = [
    <NICmsContentField.IField>{
        key: 'additional.section-header-version',
        type: NICmsContentField.EFieldType.label,
        title: 'Header Version'
    },
    <NICmsContentField.IField>{
        key: 'additional.headerTransparent',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Transparent',
        default: false
    },
    <NICmsContentField.IField>{
        key: 'additional.headerLightMode',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Light Mode',
        default: false,
    },
    <NICmsContentField.IField>{
        key: 'additional.headerHideUp',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Hide Up',
        description: 'Hide up when start scrolling down',
        default: false
    }
];

export const PAGE_HEADER_BLOCK_CONFIG: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: PAGE_HEADER_BLOCK_ID,
    onDemandOnly: true,
    block: {
        url: PAGE_HEADER_BLOCK_ID,
        scope: 'website',
        autoload: 'bootstrap'
    },
    name: 'Page Header',
    description: 'Page header component',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'logo_image',
            type: NICmsContentField.EFieldType.image,
            title: 'Logo Image',
            default: ''
        },
        {
            key: 'logo_alt',
            type: NICmsContentField.EFieldType.text,
            title: 'Logo ALT'
        },
        menuField,
        ...PAGE_HEADER_VERSION_CONFIG,
    ]
};
